import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {Metamask} from "../services/Metamask.service";
import {WalletService} from "../services/WalletService";
import {MintFactory} from "../services/MintFactory.service";

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
  ],
  providers: [
    {provide: WalletService, useClass: Metamask},
    {provide: MintFactory}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
